import { render, staticRenderFns } from "./InsightCategoryForm.vue?vue&type=template&id=6f5ed706"
import script from "./InsightCategoryForm.vue?vue&type=script&lang=js"
export * from "./InsightCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5ed706')) {
      api.createRecord('6f5ed706', component.options)
    } else {
      api.reload('6f5ed706', component.options)
    }
    module.hot.accept("./InsightCategoryForm.vue?vue&type=template&id=6f5ed706", function () {
      api.rerender('6f5ed706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/InsightCategory/InsightCategoryForm.vue"
export default component.exports